import type { PropsWithChildren } from 'react';

import { useBridgeApi } from '@/api/BridgeApi.ts';
import { ConnectionStatusBanner } from '@/components/ConnectionStatusBanner.tsx';
import { NavBar } from '@/layouts/AppLayout/NavBar.tsx';

export const AppLayout = ({
	children,
	showNavBar = false,
}: PropsWithChildren<{ showNavBar?: boolean }>) => {
	const { connectionStatus } = useBridgeApi();
	return (
		<div className="flex h-screen">
			{showNavBar && <NavBar />}
			<main className="relative z-10 flex min-w-0 flex-1 pt-4 pr-4 pb-4">
				<ConnectionStatusBanner status={connectionStatus} />
				{children}
			</main>
		</div>
	);
};
